import * as React from 'react';
import { FormModal } from 'components/containers/FormModal';
import { CustomPublishingModalRow } from '../CustomPublishingModalRow';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import { ProfilesState } from './CategoryPauseModal.controller';
import { GetCategoriesQuery } from 'models/graphql';
import { GetSocialProfiles_workspace_socialProfiles } from '../../../../models/legacy-graphql';
import { SocialProfile } from 'components/socialProfiles/SocialProfile';
import { profilesHelpers } from 'modules/Settings/Profiles/Profiles.helpers';

export type CategoryPauseModalViewProps = {
  profiles: GetSocialProfiles_workspace_socialProfiles[];
  category: GetCategoriesQuery['workspace']['categories'][number];
  onClose: VoidFunction;
  submitted: boolean;
  formInstance: UseFormReturn;
  onSubmit: SubmitHandler<ProfilesState>;
};

export const CategoryPauseModalView = (props: CategoryPauseModalViewProps): JSX.Element => {
  const profiles = props.profiles.map((profile: GetSocialProfiles_workspace_socialProfiles, i: number) => {
    return (
      <CustomPublishingModalRow
        key={profile.id}
        noBorder={props.profiles.length - 1 === i}
        useFormInstance={props.formInstance}
        fieldName={`profile-${profile.id}`}>
        <SocialProfile
          size={'medium'}
          socialProfile={profilesHelpers.remapSocialProfile(profile, false, false, false)}
          image={profile.photoUrl}
          label
        />
      </CustomPublishingModalRow>
    );
  });
  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      formInstance={props.formInstance}
      loading={props.submitted}
      onSubmit={props.onSubmit}
      size={'large'}
      submitText={'Save Changes'}
      title={props.category.name}>
      <p className={'margin-top-small-4'}>Pause specific Profiles within this Category, while keeping other Profiles active.</p>
      {profiles}
    </FormModal>
  );
};
